import Proyects from "./Proyects";
export default Proyects;